// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"b1ea499b","939":"b1ea499b"}[chunkId] + ".chunk.css";
};